import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';
import Page from '../../Components/Page';

function Profile() {
     const { t } = useTranslation();

     return (
               <Page title={t('profile')} ></Page>
     );
}

export default Profile;
